import React from "react";
import SEO from "@/components/SEO";
import FaqSection from "@/components/FaqSection";
import FinalCTA from "@/components/FinalCTA";

const FaqPage = () => (
  <>
    <SEO
      title="Wyoming Moving FAQ | Crosstown Movers"
      description="Common moving questions answered by Wyoming's trusted movers. Pricing, booking, insurance, heavy furniture and more — for Casper, Mills, and surrounding WY areas."
      path="/faq"
    />
    <section className="py-20 md:py-28 bg-[var(--ct-primary)] text-white">
      <div className="section-container">
        <div className="label-xs text-[var(--ct-secondary)] mb-3">Moving FAQ</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>
          Your Wyoming moving questions, answered.
        </h1>
      </div>
    </section>
    <FaqSection heading="Everything you need to know before your move." />
    <FinalCTA />
  </>
);

export default FaqPage;
